import React from "react";
import { default as Head } from "next/head";
import { IProductFieldsFragment } from "@govlaunch/product/src/fragments/__generated__/ProductFieldsFragment.generated";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

interface IProductPageSeoProps {
  product: IProductFieldsFragment;
}

export default function ProductPageSeo({ product }: IProductPageSeoProps) {
  const intl = useIntl();
  const image = product.logo || "https://cdn.filestackcontent.com/Ui1ayHJrQm6JZGwDARxx";

  return (
    <>
      <SeoHead
        title={intl.formatMessage(
          { defaultMessage: "{productName} – Govlaunch GovTech Products", id: "TGR2nb" },
          { productName: product.name },
        )}
        description={intl.formatMessage(
          {
            defaultMessage: "Discover {productName} and other government technology solutions on Govlaunch.",
            id: "B6VjYj",
          },
          { productName: product.name },
        )}
      />
      <Head>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:image" content={image} />
        <meta property="og:image" content={image} />
      </Head>
    </>
  );
}

export function NewProductFormPageSeo() {
  const intl = useIntl();
  const message = intl.formatMessage({ defaultMessage: "Govlaunch - New GovTech Product", id: "Twq1TR" });

  return <SeoHead title={message} description={message} />;
}

interface IEditProductFormPageSeoProps {
  productName: string;
}

export function EditProductFormPageSeo({ productName }: IEditProductFormPageSeoProps) {
  const intl = useIntl();
  const message = intl.formatMessage(
    { defaultMessage: "{productName} – Edit Govlaunch GovTech Product", id: "hIehP/" },
    { productName: productName },
  );

  return <SeoHead title={message} description={message} />;
}
